import React, { useState,useEffect } from 'react';
import { Users, FileText, Settings, DollarSign, BarChart2, Bell } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import RoleManagementModal from "./RoleManagementModal";
import api from '../../axios';
import AdminProjectTable from './AdminProjectTable';


const AdminDashboard = () => {
 
  const [showModalRoleModal, setShowRoleModal] = useState(false);
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    approved: 0,
    rejected: 0,
    total_users: 0, // Add total users
  });
  const [recentProjects, setRecentProjects] = useState([]);
  const navigate = useNavigate();

  // Fetch project stats
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const projectResponse = await api.get("/projects/stats");
        const userResponse = await api.get("/users/stats");

        setStats((prevStats) => ({
          ...prevStats,
          ...projectResponse.data,
          total_users: userResponse.data.total_users, // Store total users
        }));
      } catch (error) {
        console.error("Error fetching stats:", error);
      }
    };
    

    fetchStats();
  
    
  }, []);

  const recentActivities = [
    { id: 1, action: 'New Approver Account Created', user: 'Admin', time: '10 minutes ago' },
    { id: 2, action: 'Fee Structure Updated', user: 'Admin', time: '1 hour ago' },
    { id: 3, action: 'Customer Password Reset', user: 'Admin', time: '3 hours ago' },
    { id: 4, action: 'New Building Type Added', user: 'Admin', time: '1 day ago' },
    { id: 5, action: 'System Backup Completed', user: 'System', time: '2 days ago' },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 pt-16">
      <div className="flex-1 p-6">

        <h1 className="text-2xl font-semibold text-gray-800 mb-6">Super Administrator Dashboard</h1>
        
        {/* Stats Overview */}

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-700">Total Users</h3>
          <p className="text-2xl font-bold text-purple-600">{stats.total_users}</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-700">Total Projects</h3>
          <p className="text-2xl font-bold text-blue-600">{stats.total}</p>
        </div>
        <div className="bg-yellow-100 p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-700">Pending</h3>
          <p className="text-2xl font-bold text-yellow-600">{stats.pending}</p>
        </div>
        <div className="bg-green-100 p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-700">Approved</h3>
          <p className="text-2xl font-bold text-green-600">{stats.approved}</p>
        </div>
        <div className="bg-red-100 p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold text-gray-700">Rejected</h3>
          <p className="text-2xl font-bold text-red-600">{stats.rejected}</p>
        </div>
        </div>
        {/* Quick Actions */}
        <div className="bg-white rounded-lg shadow p-6 mb-8">
          <h2 className="text-lg font-semibold mb-4">Quick Actions</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link to="/admin/user-management">
              <div className="flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                <Users className="h-8 w-8 text-blue-600 mb-2" />
                <span className="text-sm text-center">Manage Users</span>
              </div>
            </Link>
            
            {/* <Link to="#">
              <div className="flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                <DollarSign className="h-8 w-8 text-green-600 mb-2" />
                <span className="text-sm text-center">Manage Fees</span>
              </div> 
            </Link> */}
            
            <Link to="/admin/system-settings">
              <div className="flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                <Settings className="h-8 w-8 text-gray-600 mb-2" />
                <span className="text-sm text-center">System Settings</span>
              </div>
            </Link>
            
            
            <div  
              onClick={() => setShowRoleModal(true)} 
              className="flex flex-col items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <Users className="h-8 w-8 text-blue-600 mb-2" /> {/* Updated icon */}
              <span className="text-sm text-center text-gray-800 font-medium">Manage Roles</span> {/* Updated text */}
            </div>
              <RoleManagementModal isOpen={showModalRoleModal} onClose={() => setShowRoleModal(false)} />

            
          </div>
        </div>
        
        {/* Recent Activity */}
        <AdminProjectTable />

      

      </div>
    </div>
  );
};

export default AdminDashboard;